export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8213.2da9f544.jpg";